import { React, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import FetchModule from '../../Share/Network/FetchModule';

const ExpiredMemberInfo = (props) => {
  const { data, nowPage } = props;
  const { t, languageMode } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isExistNotReceived, setIsExistNotReceived] = useState(false);

  const history = useHistory();

  const DeleteRef = useRef();

  useEffect(() => {
    if (data.notReceivedPrice === 0 || data.notReceivedPrice === undefined) setIsExistNotReceived(false);
    else setIsExistNotReceived(true);
  }, [data])

  function mouseOver() {
    DeleteRef.current.style.color = theme.primary;
  }

  function mouseLeave() {
    DeleteRef.current.style.color = theme.subBackground;
  }

  function onClickInvalidMemberInfo(e) {
    if (DeleteRef.current !== e.target) {
      window.localStorage.setItem('InvalidMemberPage', nowPage);
      window.open('/member/expired/detail/' + data.memberId, '_blank');
    }
  }
  
  // 문자발송 버튼 클릭시
  function onClickSendMessageButton() {
    var text = t('expiredMember.pushMessage').replace('{name}', data.name).replace('{membership}', data.memberShipName);

    var requestData = {
      userId: data.linkCoachId,
      data: text,
      location: 'Reservation',
      jsonData: ''
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfCoach('push_notification/send', 'POST', requestData);
        
        if (responseData.status === 200) {
          alert(t('expiredMember.pushSent'));
        }
        else if (responseData.status === 204) {
          alert(t('expiredMember.notRegistered'));
        }
      }
    )();
  }

  // 회원권 삭제 클릭시
  function onClickMemberInfoDelete() {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('member/delete/' + data.memberId, 'POST');
        if (responseData.status === 200) {
          const coachResponseData = await fetchModule.postDataOfCoach('registration/zone/delete/' + window.sessionStorage.getItem('StoreId') + '/' + data.linkCoachId, 'POST');
          if (coachResponseData.status === 200) {
            alert(t('expiredMember.deleted'));
            history.push('/member/valid');
          }
        }
        else if (responseData.status === 201) {
          alert(t('expiredMember.invalidMember'));
          history.push('/member/valid');
        }
        else if (responseData.status === 202) {
          alert(t('expiredMember.hasActiveMembership'));
        }
        else if (responseData.status === 204) {
          alert(t('expiredMember.memberNotFound'));
          history.push('/member/valid');
        }
        else if (responseData.status === 401) {
          alert(t('expiredMember.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  // 전화번호 뷰 정리 //
  function selectPhoneView() {
    if (!data.phone || data.phone === '') return t('validMember.noPhone');
    return formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('validMember.noPhone');
  }

  return (
    <TopLevelWrapper isDark={isDark} onMouseOver={mouseOver} onMouseLeave={mouseLeave} onClick={onClickInvalidMemberInfo}>
      <Table>
        <Body>
        <Tr style={{ width: '71px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '52px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.name}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '80px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '60px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.gender === 'male' ? t('validMember.male') : t('validMember.female')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '112px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '98px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.birthDay, 'YYYYMMDD').format(t('validMember.birthFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '114px'}}>
            <Td>
              <TextWrapper style={{ maxWidth: '114px' }}>
                  <Text isExistNotReceived={isExistNotReceived}>{selectPhoneView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '242px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '218px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.memberShipName}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '98px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '90px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.startDate).format(t('validMember.dateFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '180px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '90px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.endDate).format(t('validMember.dateFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr>
            <Td>
              <SendButton ref={DeleteRef} onClick={() => onClickMemberInfoDelete()}>{t('expiredMember.delete')}</SendButton>
            </Td>
          </Tr>
        </Body>
      </Table>
    </TopLevelWrapper>
  )
};

export default ExpiredMemberInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 1018px;
  height: 50px;

  margin-bottom: 8px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 30px;
  background: ${props => props.theme.subBackground};
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.primary};
    }
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
  
  margin-left: 28px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isExistNotReceived ? props.theme.primary : props.theme.subText};

  margin: 0 0 0 0;
`;

const SendButton = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      font-family: NotoSansKR-Bold;
    }
  }
`;